import React from 'react';
import PropTypes from 'prop-types';

import useQueryAppender from '../../hooks/useQueryAppender';
import constants from '../../utils/constants';
import styles from './styles.module.scss';

const Points = ({ location: { search = '' } }) => {
  const appLink = useQueryAppender(
    'https://account.kabbage.com/create-account?product=sba-loan',
    search
  );
  const {
    sites: { us },
  } = constants;

  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.header}>How to apply for PPP loans</h2>
        <ol className={styles.list}>
          <li>
            <span aria-hidden="true">1</span>
            <h3>Submit your information</h3>
            <p>
              Through our platform, we can quickly and securely review{' '}
              <a
                href={`https://${us}/resource-center/finance/required-documents-for-paycheck-protection-program-loan-application`}
                target="_blank"
                rel="noopener noreferrer"
              >
                information about you
              </a>
              , additional owners and your business, including payroll filings
              and certifications necessary for eligibility.
            </p>
          </li>
          <li>
            <span aria-hidden="true">2</span>
            <h3>We&apos;ll calculate how much you could be eligible for</h3>
            <p>
              Based on the information you submit, we’ll let you know if your
              business is eligible and the maximum amount you can access. Note,
              Kabbage can only process loans of{' '}
              <strong>up to $2 million</strong>.
            </p>
          </li>
          <li>
            <span aria-hidden="true">3</span>
            <h3>Take a loan when you’re approved</h3>
            <p>
              Securely connect your bank account, and we’ll deposit your loan
              amount when you’re ready.
            </p>
          </li>
        </ol>
        <a href={appLink} className="pill-button app-link green">
          Apply now
        </a>
      </div>
    </section>
  );
};

Points.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

Points.defaultProps = {
  location: {
    search: '',
  },
};

export default Points;
